import React from 'react';
import './Company.css';
import {Route, Routes} from "react-router-dom";
import Header from "../components/Header";
import Bot from "../components/Bot";
import Survey from "../components/Survey";
import Welcome from "../components/Welcome";
import ConversationalFormTmb from '../tmb/ConversationalForm';
import constants from "../constants";
import { Helmet } from 'react-helmet';
import groupCategoriesByParent from "../tmb/formatter";
import createQuestionsPerFlow from "../tmb/questionBuilder";
import createcategoriesPerFlow from "../tmb/formCategoryBuilder";

const Company = (props) => {
    const [company, setCompany] = React.useState()
    const [formData, setFormData] = React.useState(undefined)
    const [cfTags, setCFTags] = React.useState([])
    const [questionsPerFlow, setQuestionsPerFlow] = React.useState([])
    const [loading, setLoading] = React.useState(true)
    const [error, setError] = React.useState(undefined)
    const [categories, setCategories] = React.useState([])

    const getBaseUrlFromCurrentUrl = () => {
        const currentUrl = window.location.href;
        try {
            const parsedUrl = new URL(currentUrl);
            return parsedUrl.hostname;
        } catch (error) {
            console.error('Erreur lors de l\'extraction de l\'URL', error);
            return null;
        }
    }

    const MY_URL = getBaseUrlFromCurrentUrl();
    //let rightDeskUrl = MY_URL == "tmb.webform.tmb.cd" ? constants.intern.rightDeskUrl : constants.extern.rightDeskUrl
    // let rightDeskUrl = MY_URL == "tmb.webform.tmb.cd" ? constants.intern.rightDeskUrl : constants.extern.rightDeskUrl
    let rightDeskUrl = "https://hontogbo.rightcom.com/rightcare-tmb"

    if (window.location.hostname.split(".")[0] === 'localhost') {
        rightDeskUrl = constants.prod.rightDeskUrl
    }

    const getFormData = (data) => {
        // let webformurl = MY_URL == "tmb.webform.tmb.cd:8443" ? "https://tmb.webform.tmb.cd:8443" : "https://webform.tmb.cd"
        let webformurl = "https://hontogbo.rightcom.com/rightcare-tmb"
        let resultData = {
            "data": {
                "background_color": "#DC0C15",
                "support_link": webformurl,
                "survey_link": "",
                "text_color": "#ffffff"
            },
            "status": 200
        }

        setFormData(resultData.data)
        setCompany(data)
        getCategoriesData(data)
    }
    const getCategoriesData = (data) => {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };
        //fetch(constants.prod.rightDeskUrl)
        fetch(rightDeskUrl + "/api/v1/webform/general?subdomaine="+data.subdomain, requestOptions)
            .then(response => response.json())
            .then(result => {
                let groupCategoriesByParentData = groupCategoriesByParent(result.data.auto_priorization_subjects)
                let categoriesPerFlowData = createcategoriesPerFlow(result.data.auto_priorization_subjects)
                let questionsPerFlowData = createQuestionsPerFlow(result.data.auto_priorization_subjects)
                //console.log(questionsPerFlowData)
                //console.log(JSON.stringify(groupCategoriesByParentData))
                //console.log(groupCategoriesByParentData)
                //setCategories(result.data.auto_priorization_subjects)
                setCategories(categoriesPerFlowData)
                setCFTags(groupCategoriesByParentData)
                setQuestionsPerFlow(questionsPerFlowData)
                setLoading(false)
            })
            .catch(error => setError(error));
    }
    React.useEffect(() => {
        setLoading(true)
        setError(undefined)

        const result = {
            "data": {
              "apikey": "HP6R2KC9IT3M",
              "apps": [

                {
                  "app_code": "rightcare",
                  "app_full_description": {
                    "en": "RightDesk is a cloud-based customer service software solution. ",
                    "fr": "RightDesk est une solution logiciel de service client basee sur le cloud."
                  },
                  "app_name": "RightDesk",
                  "app_short_description": {
                    "en": "Customer Service Software",
                    "fr": "Logiciel de service client"
                  },
                  "link": "",
                  "purchased_at": "Mon Nov 08 13:50:37 UTC 2021"
                }
              ],
              "background_image_url": "",
              "companyAdress": {
                "city": "",
                "email": "e.mpoyi@tmb.cd",
                "full_adress": "",
                "phone": "+ 243818309823"
              },
              "company_owner_firstname": "Eric",
              "company_owner_lastname": "Mpoyi",
              "country": {
                "country_id": "108",
                "countrycode": "CD",
                "countryname": "DR Congo"
              },
              "customer_id": "427",
              "language": "fr",
              "logo": "",
              "logo_url": "https://right-com.com/wp-content/themes/rightcom/images/logo.png",
              "name": "Trust Merchant Bank (TMB)",
              "publickey": "HP6R2KC9IT3M",
              "resselers": [],
              "status": 1,
              "subdomain": window.location.hostname.split(".")[0] === "tmb" ? "trust-merchant-bank" : window.location.hostname.split(".")[0],
              "timezone": "",
              "updated_date": "2020-10-13 12:09:40",
              "website": "",
              "website_url": "#",
              "welcome_message": "Welcome to TMB"
            },
            "message": "Company is valid",
            "status": 200
        }

        getFormData(result.data)

    }, [props.company])

    return (
        <div className="Company">
            <>
                <Helmet>
                    <title>CX Webform</title>
                    <meta name="description" content={company?.language === "fr"?
                            "Logiciel de gestion d’expérience client propulsé par RightCom":
                            "Customer Experience Management software powered by RightCom"} />
                </Helmet>
            </>
            {loading ? <div>
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '99vh'}}>
                    {!error && <div className="loader"></div>}
                    {error && <div>{error}</div>}
                </div>
            </div> : <>
                <Routes>
                    <Route exact path={'/'}
                           element={<Welcome company={props.company} companyData={company} formData={formData}/>}/>
                    <Route exact path={'/bot'} element={<>
                        <Header company={props.company} companyData={company} formData={formData}/>
                        <ConversationalFormTmb cfTags={cfTags} questionsPerFlow={questionsPerFlow} company={props.company} companyData={company} formData={formData} categories={categories}/>
                    </>}/>
                    <Route exact path={'/survey'} element={<>
                        <Header company={props.company} companyData={company} formData={formData}/>
                        <Survey company={props.company} companyData={company} formData={formData}/>
                    </>}/>
                </Routes>
            </>}
        </div>
    );
};

export default Company;
